import _ from "lodash";
import { ColumnStateParams } from "ag-grid-community";
import { SortState } from "./sort-tool-panel";

const nextSortMap: Record<"asc" | "desc" | "null", ColumnStateParams["sort"]> = {
    asc: "desc",
    desc: null,
    null: "asc",
};

export const makeSortState = (colId: string, sortState: SortState, multiSort: boolean) => {
    const currentValue = sortState[colId];
    const finalValue = currentValue === undefined ? null : currentValue;

    if (multiSort) {
        return { ...sortState, [colId]: nextSortMap[finalValue] };
    }
    return {
        ..._.mapValues(sortState, () => null),
        [colId]: nextSortMap[finalValue],
    };
};

export const mapSortMapToColumnState = (sortState: SortState) =>
    Object.entries(sortState).map(([colId, sort]) => ({ colId, sort }));
